"use strict";

exports.__esModule = true;
exports.AboutScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _AboutPanel = require("../AboutPanel");
var _App = require("../../App");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var AboutScreen = exports.AboutScreen = /*#__PURE__*/function (_Component) {
  function AboutScreen() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(AboutScreen, _Component);
  var _proto = AboutScreen.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: "About",
      "data-testid": "AboutScreen"
    }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: "About"
    }), /*#__PURE__*/_react["default"].createElement(_AboutPanel.AboutPanel, null));
  };
  return AboutScreen;
}(_react.Component);